<template>
  <v-card class="PlanejamentoContratoFormCampos__Card--treslinhas">
    <v-container fluid grid-list-md>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-select
            v-model="focoContrato"
            :items="focoContratoConfiguracao"
            :disabled="somenteLeitura || unicoFocoContrato"
            :label="$t('label.foco')"
            item-text="texto"
            item-value="valor">
          </v-select>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-autocomplete
            id="planejamento-autocomplete-holding"
            class="custom-autocomplete"
            v-if="exibeFocoHolding"
            v-model="contrato.holding"
            return-object
            :rules="rules.requiredFunction('holding', 'nomExtensao')"
            :items="holdings"
            :label="`${$tc('label.holding', 1)} *`"
            :no-data-text="$tc('message.nenhum_registro', 1)"
            item-text="nomExtensao"
            item-value="id"
            required
            :disabled="somenteLeitura || desabilitaCliente"
            :clearable="true"
            @input="holdingAlterada"
            @click:append="() => triggerSelecao('planejamento-autocomplete-holding')"
            @click.native="(i) => buscaAutocomplete(i, buscaHoldings)"
            :search-input.sync="triggerHolding">
          </v-autocomplete>
          <v-autocomplete
            id="planejamento-autocomplete-cliente"
            class="custom-autocomplete"
            v-else
            v-model="contrato.cliente"
            return-object
            :rules="rules.requiredFunction('cliente', 'codNome')"
            :items="clientes"
            :label="`${$tc('label.cliente', 1)} *`"
            :no-data-text="$tc('message.nenhum_registro', 1)"
            item-text="codNome"
            item-value="id"
            required
            :disabled="somenteLeitura || desabilitaCliente"
            :clearable="true"
            @input="clienteAlterado"
            @click:append="() => triggerSelecao('planejamento-autocomplete-cliente')"
            @click.native="(i) => buscaAutocomplete(i, buscaClientes)"
            :search-input.sync="triggerCliente">
          </v-autocomplete>
        </v-col>
        <v-col cols="12" class="py-0"
          v-if="exibeClientePagador">
          <v-autocomplete
            id="planejamento-autocomplete-clientepagador"
            class="custom-autocomplete"
            v-model="contrato.clientePagador"
            return-object
            :rules="rules.requiredFunction('clientePagador', 'codNome')"
            :items="clientesPagadores"
            :label="`${$tc('label.cliente_pagador', 1)} *`"
            :no-data-text="$tc('message.nenhum_registro', 1)"
            item-text="codNome"
            item-value="id"
            required
            :disabled="somenteLeitura || desabilitaClientePagador"
            :clearable="true"
            @click:append="() => triggerSelecao('planejamento-autocomplete-clientepagador')"
            @click.native="(i) => buscaAutocomplete(i, buscaClientesPagadores)"
            :search-input.sync="triggerClientePagador">
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { buscaAutocomplete, triggerSelecao } from '../../../../produto/common/functions/autocomplete-utils';

export default {
  props: {
    somenteLeitura: Boolean,
    configuracao: {
      type: Object,
      required: true,
    },
    contrato: Object,
    novoContrato: Boolean,
    tipoContrato: Object,
  },
  computed: {
    ...mapGetters('contratoPeriodo', [
      'getPlanejamentoPeriodo',
    ]),
    focoContratoConfiguracao() {
      const { focoContrato } = this.configuracao;
      focoContrato.forEach((fa) => {
        if (!fa.texto) {
          fa.texto = this.$tc(fa.i18n, 1);
        }
      });
      return focoContrato;
    },
    exibeFocoHolding() {
      return this.focoContrato === 'HOLDING';
    },
    exibeClientePagador() {
      return this.configuracao.habilitaClientePagador;
    },
    unicoFocoContrato() {
      return this.focoContratoConfiguracao.length === 1;
    },
    desabilitaCliente() {
      const { unidadeNegocio } = this.contrato;
      if (!unidadeNegocio || !unidadeNegocio.id) {
        return true;
      }
      if (!this.contrato.divisao || !this.contrato.divisao.id) {
        return true;
      }
      return this.configuracao.tipoVigencia !== 'VIGENCIA_ABERTA'
        && !(this.contrato.periodoPlanejamento
        && this.contrato.periodoPlanejamento.id);
    },
    desabilitaClientePagador() {
      const { holding } = this.contrato;
      if (!holding || !holding.id) {
        return true;
      }
      return false;
    },
  },
  watch: {
    triggerHolding(val) {
      const { holding } = this.contrato;
      if (holding && holding.nomExtensao === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val) this.buscaHoldings(val);
      }, 500);
    },
    triggerCliente(val) {
      const { cliente } = this.contrato;
      if (cliente && cliente.codNome === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val) this.buscaClientes(val);
      }, 500);
    },
    triggerClientePagador(val) {
      const { clientePagador } = this.contrato;
      if (clientePagador && clientePagador.codNome === val) {
        return;
      }
      if (this.timeoutTrigger) {
        window.clearTimeout(this.timeoutTrigger);
      }
      this.timeoutTrigger = window.setTimeout(() => {
        if (val) this.buscaClientesPagadores(val);
      }, 500);
    },
  },
  data() {
    return {
      clienteResource: this.$api.cliente(this.$resource),
      planejamentoAcaoResource: this.$api.planejamentoAcaoCadastro(this.$resource),
      planoContratoAdamaResource: this.$api.planoContratoAdama(this.$resource),

      holdings: [],
      clientes: [],
      clientesPagadores: [],

      triggerHolding: null,
      triggerCliente: null,
      triggerClientePagador: null,
      timeoutTrigger: null,

      focoContrato: 'HOLDING',
      itensFocoContrato: [
        {
          valor: 'HOLDING',
          texto: this.$tc('label.holding', 1),
        },
        {
          valor: 'CLIENTE',
          texto: this.$tc('label.cliente', 1),
        },
      ],

      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredFunctionOpcional: (objLabel, valueLabel, obrigatorio) => [
          () => {
            if (!obrigatorio) {
              return true;
            }

            const objeto = this.contrato[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
        requiredFunction: (objLabel, valueLabel) => [
          () => {
            const objeto = this.contrato[objLabel] || {};
            const val = objeto[valueLabel];
            const msg = this.$t('message.campo_obrigatorio');
            return !!(val) || msg;
          },
        ],
      },
    };
  },
  methods: {
    buscaAutocomplete,
    triggerSelecao,
    buscaHoldings(autocomplete) {
      const parametros = {
        autocomplete,
        idUnidadeNegocio: this.contrato.unidadeNegocio.id,
        idTipoContrato: this.tipoContrato.id,
      };

      if (this.contrato.periodoPlanejamento
        && this.contrato.periodoPlanejamento.id) {
        parametros.idPeriodoPlanejamento = this.contrato.periodoPlanejamento.id;
      }
      this.planoContratoAdamaResource.buscarHoldings(parametros)
        .then((res) => {
          this.holdings = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaClientes(autocomplete) {
      const parametros = {
        autocomplete,
        idTipoContrato: this.tipoContrato.id,
        idUnidadeNegocio: this.contrato.unidadeNegocio.id,
        idPeriodoPlanejamento: this.contrato.periodoPlanejamento
          ? this.contrato.periodoPlanejamento.id
          : null,
      };
      this.planoContratoAdamaResource.buscarClientes(parametros)
        .then((res) => {
          this.clientes = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    buscaClientesPagadores(autocomplete) {
      const parametros = {
        autocomplete,
        idHolding: this.contrato.holding.id,
        idTipoContrato: this.tipoContrato.id,
        idUnidadeNegocio: this.contrato.unidadeNegocio.id,
        idPeriodoPlanejamento: this.contrato.periodoPlanejamento
          ? this.contrato.periodoPlanejamento.id
          : null,
      };
      this.planoContratoAdamaResource.buscarClientesPagadores(parametros)
        .then((res) => {
          this.clientesPagadores = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    limpaFocoContrato() {
      const { holding, cliente, clientePagador } = this.contrato;
      if (holding && holding.id) {
        this.contrato.holding = {};
      }
      if (cliente && cliente.id) {
        this.contrato.cliente = {};
      }
      if (clientePagador && clientePagador.id) {
        this.contrato.clientePagador = {};
      }
    },
    getContrato() {
      return this.contrato;
    },
    getTextoFoco() {
      return this.focoContrato;
    },
    holdingAlterada() {
      const { clientePagador } = this.contrato;
      if (clientePagador && clientePagador.id) {
        this.contrato.clientePagador = {};
      }
    },
    clienteAlterado(cliente) {
      this.contrato.clientePagador = cliente ? { ...cliente } : null;
      this.clientesPagadores = [
        this.contrato.clientePagador,
      ];
    },
    trataFocoContrato() {
      if (this.unicoFocoContrato) {
        this.focoContrato = this.focoContratoConfiguracao[0].valor;
      }
    },
    setContratoEdicao(contrato) {
      const { cliente, holding, clientePagador } = contrato;
      if (holding) {
        this.focoContrato = 'HOLDING';
        this.holdings = [holding];
        this.clientesPagadores = [clientePagador];
      } else {
        this.focoContrato = 'CLIENTE';
        this.clientes = [cliente];
        this.clientesPagadores = [clientePagador];
      }
    },
  },
  mounted() {
    this.trataFocoContrato();
  },
};
</script>
